import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskEmailMobile'
})
export class MaskEmailMobilePipe implements PipeTransform {

  transform(value: any, type: string, noFirstShowChar: number, noLastShowChar: number): any {
    const subst = `*`;
    if (!value) {
      return [];
    }
    if (value.indexOf('@') > -1 && type === 'email') {
      const emailRegex = '\\S(?<=.{' + noFirstShowChar + '})(?=\\S{' + noLastShowChar + '})';
      const rx = new RegExp(emailRegex, 'gm');
      value = value.replace(rx, subst);
    } else if (type === 'mobile') {
      const mobileRegex = '\\d(?<=.{' + noFirstShowChar + '})(?=\\d{' + noLastShowChar + '})';
      const rx = new RegExp(mobileRegex, 'gm');
      value = value.replace(rx, subst);
    }
    return value;
  }

}
